import React from 'react';

import useResizeBar from '@dashboard/hooks/useResizeBar';
import { Paper, Stack, SxProps } from '@mui/material';
import { useEditMode, useNavigationBarMode } from '@wp-block-builder/editor/hooks';

import NavigatorSidebarContents from './NavigatorSidebarContents';
import { NavigatorStoreProvider } from './NavigatorStore';

const SIDEBAR_WIDTH = 240;

const SX_PROPS: SxProps = {
  position: 'absolute',
  top: 48,
  right: 0,
  bottom: 0,
  overflow: 'auto',
  zIndex: 'appbar',
  maxWidth: { md: 400 },
  minWidth: { md: 192 },
};

export default function NavigatorSidebar() {
  const [mode] = useNavigationBarMode();
  const [editMode] = useEditMode();
  const { resizeBar, width } = useResizeBar({ defaultWidth: SIDEBAR_WIDTH, position: 'right' });

  if (mode === 'HIDDEN' || editMode === 'PREVIEW') {
    return null;
  }
  return (
    <Stack
      component={Paper}
      direction="row"
      justifyContent="space-between"
      alignItems="stretch"
      sx={{ ...SX_PROPS, width: { md: width } }}
      onClick={(ev) => ev.stopPropagation()}
    >
      {resizeBar}
      <NavigatorStoreProvider>
        <NavigatorSidebarContents />
      </NavigatorStoreProvider>
    </Stack>
  );
}
